import { Page } from '@/core/architecture'

import { DeactivationCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DeactivationCompletion Page
 * Implemented as a practical sample.
 */
export const DeactivationCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return <DeactivationCompletionTemplate state={state} {...actions} />
}
